import React from "react";
import "./styles/News.css";

const News = () => {
  return (
    <div className="news-container">
      <h1 className="news-title">These are the following news for the Pokémon Autochess!</h1>

      {/* 🔸 News Block 1 */}
      <div className="news-block">
        <img src="https://poke-meta.com/static/images/pokemon/mewtwo.png" alt="New Pokémon" className="pokemon-news-img" />

        <div className="abilities-row">
          <div className="ability-box">
            <img src="https://poke-meta.com/static/images/abilitys/mewtwo1.png" alt="Ability 1" className="ability-img" />
            <p className="ability-text">Future Sight: Pull the farthest opponent to your side and deal 450%/450%/4500% attack damage to them after a while</p>
          </div>
          <div className="ability-box">
            <img src="https://poke-meta.com/static/images/abilitys/mewtwo2.png" alt="Ability 2" className="ability-img" />
            <p className="ability-text">Psychic Break: Sends a telekinesis to the target opponent, dealing 150%/150%/1500% attack damage, gaining 90% damage during the process
            Relief; Then deal 200%/200%/2000% attack damage to the opponent and its surroundings and knock the opponent into the air.</p>
          </div>
          <div className="ability-box">
            <img src="https://poke-meta.com/static/images/abilitys/mewtwo3.png" alt="Ability 3" className="ability-img" />
            <p className="ability-text">Teleportation: Super evolves into Super Mewtwo X, increasing attack speed by 100%, defense and special defense by 1500, and attack by more
            30%, which will teleporte to a random opponent to attack at regular intervals</p>
          </div>
        </div>
      </div>

      {/* 🔸 News Block 2 */}
      <div className="news-block">
        <img src="https://poke-meta.com/static/images/pokemon/korraidon.png" alt="New Pokémon" className="pokemon-news-img" />

        <div className="abilities-row">
          <div className="ability-box">
            <img src="https://poke-meta.com/static/images/abilitys/korr1.png" alt="Ability 1" className="ability-img" />
            <p className="ability-text">Thunder: Summons clouds above that can chop down thunderstorms. The summoned cloud will move slowly towards the nearest opponent, passing one at a time
            For a period of time, it will slash lightning, dealing 135%/135%/1350% damage and reducing its special defense by 30%.</p>
          </div>
          <div className="ability-box">
            <img src="https://poke-meta.com/static/images/abilitys/korr2.png" alt="Ability 2" className="ability-img" />
            <p className="ability-text">Charging Beam: Deals 630%/630%/6300% Special Attack damage over time to opponents in a rectangle in front of you</p>
          </div>
          <div className="ability-box">
            <img src="https://poke-meta.com/static/images/abilitys/korr3.png" alt="Ability 3" className="ability-img" />
            <p className="ability-text">Drop 5 meteorites in a row, dealing 220%/220%/2200% Special Attack damage to the opponent and knocking the opponent into the air</p>
          </div>
        </div>
      </div>

      {/* 🔸 Final Highlight Item Style Block */}
      <div className="highlight-block">
        <img src="https://poke-meta.com/static/images/items/arrow.png" alt="New Feature" className="highlight-img" />
        <p className="highlight-text">
          Introducing a new passive item: <strong>When a teammate's Pokémon Projection is defeated, self damage is increased by 5% and attack speed is increased by 10%</strong> 
        </p>
      </div>

      {/* 🔸 Final Highlight Item Style Block */}
      <div className="highlight-block">
        <img src="https://poke-meta.com/static/images/items/metronom.png" alt="New Feature" className="highlight-img" />
        <p className="highlight-text">
          Introducing a new passive item: <strong>Each time a teammate Pokémon Projection uses a normal move, it increases the damage of its own move by 4%</strong> 
        </p>
      </div>
    </div>
  );
};

export default News;
